import { z } from 'zod';

import { AUTOSHIP_FREQUENCY_VALUES, AUTOSHIP_UNIT_OF_MEASURE_VALUES } from '@libs/common-types';

export const miniPdpFormSchema = z.object({
    selectedSku: z.string().min(1, 'SKU is required'),
    fulfilmentMethod: z.enum(['bopis', 'sdd', 'sth']),
    quantity: z.number().int().positive(),
    purchaseOption: z.enum(['one-time', 'autoship']),
    subscriptionType: z.enum(['new', 'existing']),
    autoshipFrequency: z.enum(AUTOSHIP_FREQUENCY_VALUES),
    autoshipUnit: z.enum(AUTOSHIP_UNIT_OF_MEASURE_VALUES),
});
